
import {
  defineComponent,
  computed,
  onMounted,
  nextTick,
  ref,
  watch,
  reactive,
  onBeforeUnmount
} from 'vue'
import { useStore } from 'vuex'
import { IStoreType } from '@/store/types'
import { IarticleListType } from '@/store/page-index/types'
import { useRouter } from 'vue-router'

import { videoPlay } from 'vue3-video-play' // 引入组件
import 'vue3-video-play/dist/style.css' // 引入css

import { ElMessage, ElLoading } from 'element-plus'

export default defineComponent({
  components: { videoPlay },
  setup() {
    const store = useStore<IStoreType>()
    // 获取初始数据
    const articleList = computed(() => {
      return store.state.pageMylifeModule.MylifeList
    })
    // 优化数据
    // 当前页数
    let num = 0
    // 最大页数
    let maxNum = 0
    // 全部数据列表
    let result: IarticleListType[][] = []
    // 当前页列表
    let article = ref<IarticleListType[]>([])
    let optimize = (lists: IarticleListType[]) => {
      result = []
      let list = lists
      list = list.sort((a, b) => Date.parse(b.time) - Date.parse(a.time))
      for (var i = 0; i < list.length; i += 5) {
        result.push(list.slice(i, i + 5))
      }
      maxNum = result.length - 1
      article.value = article.value.concat(result[num])
      setTimeout(() => {
        window.scroll(0, 0)
      }, 1)
    }
    // 滑动分页
    let isRefreshBool = ref(true)
    let scrollF = () => {
      let loading = ElLoading.service({
        lock: true,
        text: '正在请求数据....',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      setTimeout(() => {
        if (num >= maxNum) {
          isRefreshBool.value = false
          loading?.close()
          return ElMessage({
            message: '已经没有更多了',
            type: 'warning'
          })
        } else {
          num++
          article.value = article.value.concat(result[num])
          if (num >= maxNum) {
            isRefreshBool.value = false
          }
          loading?.close()
        }
      }, 1000)
    }
    watch(articleList, (n) => {
      optimize(n)
    })
    onMounted(() => {
      if (!articleList.value.length) {
        // 调用初始数据接口
        store.dispatch('pageMylifeModule/onArticle', { str: 'mylife' })
      } else {
        optimize(articleList.value)
      }
    })
    // 视屏
    const options = {
      width: '480px', //播放器高度
      height: '400px', //播放器高度
      color: '#409eff', //主题色
      muted: false, //静音
      webFullScreen: false,
      speedRate: ['0.75', '1.0', '1.25', '1.5', '2.0'], //播放倍速
      autoPlay: false, //自动播放
      loop: false, //循环播放
      mirror: false, //镜像画面
      ligthOff: false, //关灯模式
      volume: 0.3, //默认音量大小
      control: true, //是否显示控制器
      title: '', //视频名称
      src: 'http://vjs.zencdn.net/v/oceans.mp4', //视频源
      poster: '' //封面
    }
    const Goptions = (src: string, img: string) => {
      options.src = src
      options.poster = img
      if (document.body.clientWidth <= 768) {
        options.width = `${document.body.clientWidth - 40}px`
        options.height = `${document.body.clientWidth - 120}px`
      }
      return options
    }
    return {
      articleList,
      article,
      Goptions,
      isRefreshBool,
      scrollF
    }
  }
})
